import { load } from '@shopify/theme-sections';

import '../sections/slideshow';
import '../sections/testimonials';
import '../sections/reviews';
import '../sections/logo-list';
import '../sections/feature-list';
import '../sections/featured-collection-slider';
import '../sections/index-video-slider';
import '../sections/featured-blog-post-slider';
import '../sections/modal';
import '../sections/signup-success';
import VideoModal from '../sections/video-modal';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  VideoModal();
  console.log('🔮 Index: Loaded');
});
